import { render, staticRenderFns } from "./add-edit-multi-econsent-education.vue?vue&type=template&id=36867d90&scoped=true&"
import script from "./add-edit-multi-econsent-education.vue?vue&type=script&lang=js&"
export * from "./add-edit-multi-econsent-education.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-multi-econsent-education.vue?vue&type=style&index=0&id=36867d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36867d90",
  null
  
)

component.options.__file = "add-edit-multi-econsent-education.vue"
export default component.exports